import { ToggleButton as MuiToggleButton, styled } from '@mui/material';

const REDUCE_PADDING_BREAKPOINT = 1620;

export const ToggleButton = styled(MuiToggleButton)(() => ({
  padding: '0.5rem 4rem',
  marginBottom: '1rem',
  [`@media (min-width: ${REDUCE_PADDING_BREAKPOINT}px)`]: {
    padding: '0.5rem 1rem',
  },
}));
